import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from '@exchange/environment'
import { AuthService } from 'ng-client-auth'

@Component({
  selector: 'app-tracker',
  template: '<div></div>',
  standalone: false
})
export class DefaultComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {}
  ngOnInit(): void {
    this.authService.getAppUserInfo().subscribe(user => {
      if (user?.DefaultNavigation) {
        window.location.href = environment.pmroot + user.DefaultNavigation
      } else {
        window.location.href = environment.pmroot + 'caseload'
      }
    })
  }
}
